import { render } from "./BackupDiff.vue?vue&type=template&id=327fa742"
import script from "./BackupDiff.vue?vue&type=script&lang=js"
export * from "./BackupDiff.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__